import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTicketPriority } from '../../api/TICKET/ticketMeta';
import { toast } from 'react-toastify';

export const useCreateTicketPriority = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createTicketPriority,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['ticket-priorities'] });
            toast.success('Priorité créée avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la création de la priorité');
        },
    });
};
